import { render, staticRenderFns } from "./HeaderLoader.vue?vue&type=template&id=6cf03648"
import script from "./HeaderLoader.vue?vue&type=script&lang=js"
export * from "./HeaderLoader.vue?vue&type=script&lang=js"
import style0 from "./HeaderLoader.vue?vue&type=style&index=0&id=6cf03648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports